import { useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const INACTIVITY_LIMIT = 12 * 60 * 60 * 1000;  //12hr --> for 30min = 30 * 60 * 1000

export const useAutoLogout = () => {
    const timerRef = useRef(null);
    const navigate = useNavigate()

    const handleLogout = () => {
        localStorage.clear();
        sessionStorage.clear();

        toast.success("You have been logged out successfully. See you soon!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });

        // navigate("/", { replace: true });
        setTimeout(() => {
            window.location.reload();
        }, 500)
    };


    const resetTimer = () => {
        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
            handleLogout();
        }, INACTIVITY_LIMIT);
    };

    useEffect(() => {
        const events = ["mousemove", "keydown", "click", "scroll"];
        events.forEach((event) => window.addEventListener(event, resetTimer));

        resetTimer();

        return () => {
            if (timerRef.current) clearTimeout(timerRef.current);
            events.forEach((event) =>
                window.removeEventListener(event, resetTimer)
            );
        };
    }, []);

    return { handleLogout };
};